import {
  base_colorContentBorderSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH3, fontRegular, fontSupportMedium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const settingsStatusCardStyle = css`
  &.SettingsStatusCard {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .SettingsStatusCard-header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(2)};
  }

  .SettingsStatusCard-titleGroup {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }

  .SettingsStatusCard-title {
    ${fontH3};
    margin: 0;
    color: ${text_colorTextPrimary};
  }

  .SettingsStatusCard-bannerBody {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .SettingsStatusCard-bannerTitle {
    ${fontSupportMedium};
    color: ${text_colorTextPrimary};
  }

  .SettingsStatusCard-bannerDescription {
    ${fontSupportMedium};
    color: ${text_colorTextSecondary};
  }

  .SettingsStatusCard-body {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }

  .SettingsStatusCard-bodyText {
    ${fontRegular};
    margin: 0;
    color: ${text_colorTextPrimary};
  }

  .SettingsStatusCard-footer {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing(2)};
    border-top: 1px solid ${base_colorContentBorderSecondary};
    padding-top: ${spacing(4)};
  }

  .SettingsStatusCard-footerText {
    ${fontSupportMedium};
    color: ${text_colorTextSecondary};
  }
`

export const cardDetailListStyle = css`
  &.CardDetailList {
    display: flex;
    flex-direction: column;
    gap: ${spacing(6)};
  }

  .CardDetailRow {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .CardDetailRow-label {
    ${fontSupportMedium};
    color: ${text_colorTextSecondary};
  }

  .CardDetailRow-value {
    ${fontRegular};
    color: ${text_colorTextPrimary};
  }

  .CardDetailRow-value.capitalize {
    text-transform: capitalize;
  }

  .CardDetailRow-pill {
    display: flex;
  }
`
